import * as React from "react";
import type { SVGProps } from "react";
const SvgMarketIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="market_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M551.68 216.277c-57.899-30.89-109.227-45.61-182.4-45.61-42.24 0-83.285 6.229-117.803 16.512a45.653 45.653 0 0 0-80.81 29.098V807.68a45.653 45.653 0 0 0 91.264 0V574.89c34.73-6.357 77.482-10.24 107.306-10.24 55.51 0 93.867 10.582 140.544 35.457 45.782 24.405 99.414 36.266 163.414 36.266 67.242 0 125.994-13.184 165.376-37.461a32.853 32.853 0 0 0 10.88-10.624 25.43 25.43 0 0 0 3.882-13.355v-333.44l-.341-4.266a27.733 27.733 0 0 0-7.68-14.336 38.4 38.4 0 0 0-15.616-9.387 46.805 46.805 0 0 0-19.328-2.005c-6.57.725-12.8 2.773-18.005 5.973-25.302 15.616-68.864 24.832-119.254 24.832-49.621 0-87.978-8.277-121.386-26.027z"
    />
  </svg>
);
export default SvgMarketIcon;
